import { render, staticRenderFns } from "./FinalData.vue?vue&type=template&id=3ed2d99d&scoped=true"
import script from "./FinalData.vue?vue&type=script&lang=js"
export * from "./FinalData.vue?vue&type=script&lang=js"
import style0 from "./FinalData.vue?vue&type=style&index=0&id=3ed2d99d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2d99d",
  null
  
)

export default component.exports